<template>
  <div>
    <project-sidebar class="bg-dark float-left vh-100 overflow-y" :style="`width: ${WIDTH_USER_SIDEBAR}px;`" />

    <div :style="`margin-left: ${WIDTH_USER_SIDEBAR}px;`">
      <router-view class="inner-wrapper m-auto" />
    </div>
  </div>
</template>

<script>
import { WIDTH_USER_SIDEBAR } from "@/constants/style";

import ProjectSidebar from "@/components/Sidebar/Project/";

export default {
  name: "LayoutDesktop",
  components: { ProjectSidebar },
  data: () => ({
    WIDTH_USER_SIDEBAR,
  }),
};
</script>
